import { defineStore } from 'pinia';
import { useToast } from 'vue-toastification';

const baseUrl = process.env.VUE_APP_PROD_URL;

export const usePlaylistsStore = defineStore('userPlaylists', {
  state: () => ({
    playlists: [],
    loaded: false,
    loading: false,
  }),
  actions: {
    async ensureLoaded() {
      if (this.loaded || this.loading) return;
      await this.refresh();
    },
    async refresh() {
      this.loading = true;
      try {
        const res = await fetch(`${baseUrl}/user/playlists`, { credentials: 'include' }).then((r) => r.json());
        this.playlists = res.data?.playlists || [];
        this.loaded = true;
      } catch (err) {
        console.error('Error loading playlists:', err);
      } finally {
        this.loading = false;
      }
    },
    async createPlaylist(name) {
      const toast = useToast();
      try {
        const res = await fetch(`${baseUrl}/user/playlists`, {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ name }),
        }).then((r) => r.json());

        if (!res.success) {
          throw new Error(res.message || 'Could not create playlist');
        }
        this.playlists.unshift({ ...res.data.playlist, song_count: 0 });
        toast.success(`Created "${name}"`);
        return res.data.playlist;
      } catch (err) {
        toast.error(err.message || 'Could not create playlist');
        return null;
      }
    },
    async addSongToPlaylist(playlistId, videoId) {
      const toast = useToast();
      try {
        const res = await fetch(`${baseUrl}/user/playlists/${playlistId}/songs`, {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ songId: videoId }),
        }).then((r) => r.json());

        if (!res.success) {
          throw new Error(res.message || 'Could not add song');
        }
        toast.success('Added to playlist');
        return true;
      } catch (err) {
        toast.error(err.message || 'Could not add song to playlist');
        return false;
      }
    },
    async getPlaylist(playlistId) {
      const res = await fetch(`${baseUrl}/user/playlists/${playlistId}`, { credentials: 'include' }).then((r) => r.json());
      if (!res.success) return null;
      return res.data.playlist;
    },
  },
});
